module.exports = __webpack_public_path__ + "media/packs/images/transit/not-visited-fb2c6f54310ed6c1d163f131b9dd4478.svg";